import { useEffect, useState } from "react";
import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { IconButton } from "@mui/material";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import axios from "axios";
import { Input, Modal, Popconfirm, Tooltip } from "antd";
import { Link, useNavigate } from "react-router-dom";

import { Button, Dropdown } from "antd";
import { GoPlusCircle } from "react-icons/go";
import { IoFilterCircleOutline } from "react-icons/io5";
import { PiHamburger } from "react-icons/pi";
import { IoDocumentTextOutline } from "react-icons/io5";
import { IoMdPerson } from "react-icons/io";
import { MdOutlineIncompleteCircle } from "react-icons/md";
import {
  TbBrandProducthunt,
  TbLayoutSidebarRightCollapseFilled,
} from "react-icons/tb";
import { useMessage } from "../../Components/MessageProvider/MessageProvider";
import axiosInstance from "../../Components/axiosInstance/AxiosInstance";
import { CiCirclePlus } from "react-icons/ci";
import { message } from "antd";

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Gingerbread", 356, 16.0, 49, 3.9),
];

const items = [
  {
    key: "1",
    label: (
      <Link
        className=" block w-[100%] flex items-center justify-start gap-1"
        rel="noopener noreferrer"
        to="/tickets"
      >
        <IoDocumentTextOutline className="font-[30px]" />
        Ticketlar
      </Link>
    ),
  },
  {
    key: "2",
    label: (
      <Link
        className=" block w-[100%] flex items-center justify-start gap-1"
        rel="noopener noreferrer"
        to="/yukxati"
      >
        <IoDocumentTextOutline className="font-[30px]" /> Yuk xatlari
      </Link>
    ),
  },
  {
    key: "3",
    label: (
      <Link
        className=" block w-[100%] flex items-center justify-start gap-1"
        rel="noopener noreferrer"
        to="/customers"
      >
        <IoMdPerson /> Xaridorlar
      </Link>
    ),
  },
  {
    key: "4",
    label: (
      <Link
        className=" block w-[100%] flex items-center justify-start gap-1"
        rel="noopener noreferrer"
        to="/customers"
      >
        <TbLayoutSidebarRightCollapseFilled /> Ko'cha
      </Link>
    ),
  },
  {
    key: "5",
    label: (
      <Link
        className=" block w-[100%] flex items-center justify-start gap-1"
        rel="noopener noreferrer"
        to="/products"
      >
        <TbBrandProducthunt /> Dorilar
      </Link>
    ),
  },
];

export default function Products() {
  let navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const messageApi = useMessage();
  const elementRef = React.useRef(null);
  let [personBy, setPersonBy] = React.useState(false);
  let [dataDetail, setDataDetail] = React.useState(null);
  let [sections, setSections] = React.useState(1);
  let [openStatByModal, setOpenStatByModal] = React.useState(false);

  let getProducts = async (row) => {
    try {
      console.log(row);
      setPersonBy(row);
      // setDataDetail;
      setLoading(true);

      let { data } = await axiosInstance.get("/api/add-product");

      console.log(data);

      if (data.success) {
        setOpenStatByModal(true);
        setDataDetail(data.customer);

        setData(data.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const confirm = async (row) => {
    try {
      console.log(row);
      let { data } = await axiosInstance.delete("/api/add-product/" + row.id);
      console.log(data);
      getProducts();
      message.success(row.name + " O'chdi");
    } catch (error) {
      console.log(error);
    }
  };
  const cancel = (e) => {
    console.log(e);
    //   message.error("Click on No");
  };

  useEffect(() => {
    getProducts();
  }, []);

  //   modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [name, setName] = useState("");

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    setIsModalOpen(false);
    try {
      setLoading(true);

      let { data } = await axiosInstance.post("/api/add-product", {
        name: name,
      });

      console.log(data);

      if (data.success) {
        setOpenStatByModal(true);
        setDataDetail(data.customer);
        getProducts();
        setName("");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <div className="max-w-[900px] m-auto w-[100%] flex  bg-[#fff] z-10 flex-row  items-center justify-between p-[10px]">
        <h2 className="bold text-[20px]">Mahsulotlar</h2>

        <div className="flex gap-1">
          <Dropdown
            menu={{
              items,
            }}
            placement="topRight"
            arrow
          >
            <Button>
              <PiHamburger />
            </Button>
          </Dropdown>
        </div>
      </div>
      <div className="my-[30px] w-[100%] md:w-[90%] bg-[#fff] rounded-xl m-auto">
        <div className="text-[24px] my-[16px] mb-[4px] text-[#222222] font-[600] md:px-[20px]"></div>
        <div className="w-[100%] overflow px-[20px]">
          <div className=" mx-auto md:p-4">
            <div className="flex items-center justify-between ">
              <h1 className="text-2xl font-bold">Mahsulotlar</h1>
              <div className="flex flex-col md:flex-row items-end md:justify-end p-4">
                <IconButton
                  onClick={showModal}
                  aria-label="print"
                  color="primary"
                >
                  <CiCirclePlus />
                </IconButton>
                <Modal
                  title="Mahsulot qo'shish"
                  open={isModalOpen}
                  onOk={handleOk}
                  onCancel={handleCancel}
                >
                  <Input
                    placeholder="Mahsulot nomi"
                    value={name}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setName(e.target.value);
                    }}
                  />
                </Modal>
              </div>
            </div>
            <div className="overflow-x-auto">
              <div ref={elementRef}>
                {data ? (
                  <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <span className="text-[#6b7280] text-[14px]">
                              Номи
                            </span>
                          </TableCell>
                          <TableCell align="left">
                            <span className="text-[#6b7280] text-[14px]">
                              Коп
                            </span>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data?.map((row, i) => (
                          <TableRow
                            key={row.name}
                            sx={{
                              cursor: "pointer",
                              background:
                                row.status == "Nasiya"
                                  ? "#FF6969"
                                  : row.status == "Birjadan yutadi"
                                  ? "#E7D37F"
                                  : row.status == "Bergan"
                                  ? "#06D001"
                                  : row.status == "Birja"
                                  ? "#F3FF90"
                                  : "white",
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              <Popconfirm
                                title="O'chirish"
                                description={
                                  `'${row.name}'` +
                                  " O'chirishga ishonchingiz komilmi?"
                                }
                                onConfirm={() => {
                                  confirm(row);
                                }}
                                onCancel={cancel}
                                okText="Yes"
                                cancelText="No"
                              >
                                <span className="text-[#6b7280] text-[14px]">
                                  {i + 1}.
                                </span>
                                <span className="text-[#6b7280] text-[14px]">
                                  {row.name}
                                </span>
                              </Popconfirm>
                            </TableCell>

                            <TableCell align="left">
                              <span className="text-[#6b7280] text-[14px]">
                                0
                              </span>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
